<template>
    <div>
        <p class="loading text-center pt-5" v-if="loader.firstLoading">
            <i class="fas fa-spinner fa-spin" style="font-size:2rem"></i>
        </p>

        <div v-else>
            <div v-if="loader.rows.length">

                <base-table type="hover" :data="loader.rows">

                    <template slot="columns">
                        <th width="50px"></th>
                        <th>{{ $t('xapi.common.name') }}</th>
                        <th>{{ $t('xapi.common.id') }}</th>
                        <th class="text-right" v-if="showLinks"></th>
                    </template>

                    <template slot-scope="{row}">

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null" 
                            @click="open(row)" 
                            class="td-actions"
                        >
                            <div class="index text-warning">
                                {{ row.index }}
                            </div>
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            <i :class="'tim-icons text-info-light mr-1 '+row.icon"></i>
                            {{ row.name }}
                        </td>

                        <td @mouseover="hovered=row.index" 
                            @mouseleave="hovered=null"
                            @click="open(row)"
                        >
                            {{ row.id.type }}
                            <div v-if="row.id.part1"><small>{{ row.id.part1 }}</small></div>
                            <div v-if="row.id.part2"><small>{{ row.id.part2 }}</small></div>
                        </td>

                        <td class="text-right" 
                            @mouseover="hovered=row.index"
                            @mouseleave="hovered=null"
                            @click="open(row)"
                            v-if="showLinks"
                        >
                            <div>
                                <a href="#" @click.prevent.stop="openStatements(row)">
                                    {{ $t('xapi.common.statements') }}
                                </a>
                            </div>
                            <div>
                                <a href="#" @click.prevent.stop="openProfiles(row)">
                                    {{ $t('xapi.common.profiles') }}
                                </a>
                            </div>
                        </td>

                    </template>

                </base-table>

                <div slot="footer" class="text-center mt-3" v-if="loader.hasMore()">
                    <base-button round type="primary" :loading="loader.nextLoading" @click="loader.nextLoad()">
                        {{ $t('common.load-more') }}
                    </base-button>
                </div>

            </div>
            
            <div v-else>
                <p class="text-center pt-3">{{ $t('xapi.common.search.no-result') }}</p>
            </div>

        </div>

        <portal to="modals">

            <modal class="fullscreen" :title="'#'+index" title-color="warning" v-model="modals.viewer">
                <json-viewer :data="selected"></json-viewer>
            </modal>

        </portal>
    </div>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        props: {
            showLinks: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
                loader: this.$xapi.loaders.agents,
                filters: this.$xapi.filters.agents,
                modals: new ModalsController('viewer'),
                hovered: null,
                selected: null,
                index: null,
            }
        },

        created() {
            this.loader.setMapData(this.mapData)
            this.loader.firstLoad()
        },

        methods: {

            mapData(item, index) {
                return {
                    index: index + 1,
                    data: this.xapiAgent(item),
                    icon: this.icon(item),
                    name: this.name(item),
                    id: this.id(item),
                }
            },

            xapiAgent(item) {
                let parts = item.vid.split('::')
                let agent = {
                    objectType: item.is_group ? 'Group' : 'Agent',
                }
                if (item.name) {
                    agent.name = item.name
                }
                if (parts[0] == 'account') {
                    let accountParts = parts[1].split('@')
                    agent[parts[0]] = {
                        name: accountParts[0],
                        homePage: accountParts[1]
                    }
                } else {
                    agent[parts[0]] = parts[1]
                }
                return agent
            },

            icon(item) {
                let agent = this.xapiAgent(item)
                return agent.objectType == 'Group' ? 'icon-multiple-19' : 'icon-single-02'
            },

            name(item) {
                let agent = this.xapiAgent(item)
                return agent.name ? agent.name : ''
            },

            id(item) {
                let agent = this.xapiAgent(item)
                let id = {}
                if (agent.mbox) {
                    id.type = 'mbox'
                    id.part1 = String(agent.mbox).substr(7)
                } else if (agent.account) {
                    id.type = 'account'
                    id.part1 = agent.account.name
                    id.part2 = agent.account.homePage
                } else if (agent.openid) {
                    id.type = 'openid'
                    id.part1 = agent.openid
                } else {
                    id.type = 'mbox_sha1sum'
                    id.part1 = agent.mbox_sha1sum
                }
                return id
            },

            open(row) {
                this.selected= row.data
                this.index = row.index
                this.modals.open('viewer')
            },

            openStatements(row) {
                this.$xapi.filters.statements.reset()
                this.$xapi.filters.statements.actor = this.agentIdFilter(row)
                this.$router.push({ name: 'statements' })
            },

            openProfiles(row) {
                this.$xapi.filters.agentProfiles.reset()
                this.$xapi.filters.agentProfiles.agentId = this.agentIdFilter(row)
                this.$router.push({ name: 'agent-profiles' })
            },

            agentIdFilter(row) {
                if (row.id.type == 'mbox') {
                    return row.id.part1
                } else if (row.id.type == 'account') {
                    if (row.id.part2) {
                        return 'account:' + row.id.part1 + '@' + row.id.part2
                    } else {
                        return 'account:' + row.id.part1
                    }
                } else if (row.id.type == 'openid') {
                    return 'openid:' + row.id.part1
                } else if (row.id.type == 'mbox_sha1sum') {
                    return 'sha1sum:' + row.id.part1
                }
            }
        }
    }
</script>

<style scoped>

    td:hover {
        cursor: pointer;
    }
    td .index {
        width: 30px;
        height: 30px;
        text-align: center;
        padding-top: 5px;
    }

</style>